module.exports = __webpack_public_path__ + "static/img/game-logo-chick.40315a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build922/assets/image/gamelogo/game-logo-chick.png
// module id = wZ63
// module chunks = 0 1 2 3 4 5 6